import client from 'API/client'

const GEO_PREFIX = 'geo/area'

export const getAreas = () => client.get(GEO_PREFIX)

export const deleteArea = (areaId) => client.delete(`${GEO_PREFIX}/${areaId}`)

export const saveParamArea = (paramArea) => client.post(GEO_PREFIX, paramArea)

export const saveParamShape = (areaId, paramShape) => client.post(`${GEO_PREFIX}/${areaId}/shape`, paramShape)

export const updateParamArea = (areaId, paramArea) => client.patch(`${GEO_PREFIX}/${areaId}`, paramArea)

export const updateParamShape = (shapeId, paramShape) => client.patch(`geo/shape/${shapeId}`, paramShape)

export const getAreaById = (id) => client.get(`${GEO_PREFIX}/${id}/shapes`)
